import { BusinessContextModel } from '../../core/model/BusinessContext.model';
import { DashboardHttpQueryConfig } from './DashboardHttpQuery.config';

export const DashboardBusinessContext: BusinessContextModel = {
  translateNamespace: 'dashboard',
  queries: DashboardHttpQueryConfig,
};
